// @components
import { useTranslation } from "react-i18next";
import DynamicForm from "./components/DynamicForm";

const ServiceFormPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col mt-6 px-6 lg:px-0">
      <h1 className="text-[15px] lg:text-[18px] font-semibold text-gray-900 mb-6 ">
        {t("categoriesPage.requestTitleForm")}
      </h1>
      <DynamicForm />
    </div>
  );
};

export default ServiceFormPage;
